import React from "react";


const Tooltip = ({ text, children, position = "top" }) => {
    return (
        <span className={`tooltip-wrapper tooltip-${position}`}>
            {children}
            <span className="tooltip-text">{text}</span>
        </span>
    );
};

export default Tooltip;
